import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { DataFromText } from 'owa-locstrings/lib/strings/datafromtext.locstring.json';
import { AssetErrorRetryable } from 'owa-timestream-asset-sdk';
import loc, { format } from 'owa-localize';
import { assetErrorWeather } from '../weather.locstring.json';
import WeatherDetailsView from './WeatherDetailsView';
import WeatherLocationPicker from './WeatherLocationPicker';
import WeatherMultidayView from './WeatherMultidayView';
import useWeatherViewState from '../hooks/useWeatherViewState';
import type { WeatherPayload, WeatherDetailsViewProps } from '../schema';

export default observer(function WeatherView({ payload }: { payload: WeatherPayload }) {
    const {
        locationName,
        locationPersona,
        weatherInfo,
        multidayForecast,
        attribution,
        fetchWeatherCallback,
        isLoading,
        showRetryError,
    } = useWeatherViewState(payload);

    return (
        <div className={styles.weatherAssetContainer}>
            <WeatherLocationPicker
                selectedLocation={locationPersona}
                locationName={locationName}
                isLoading={isLoading}
            />
            {weatherInfo?.skyCode !== undefined &&
                weatherInfo?.skyText &&
                weatherInfo?.tempUnit !== undefined && (
                    <WeatherDetailsView {...(weatherInfo as WeatherDetailsViewProps)} />
                )}
            {!!multidayForecast && multidayForecast.forecast.length > 0 && (
                <WeatherMultidayView forecast={multidayForecast.forecast} />
            )}
            {!!attribution && !!weatherInfo && (
                <div className={styles.attribution}>{format(loc(DataFromText), attribution)}</div>
            )}
            {showRetryError && !isLoading && (
                <AssetErrorRetryable
                    errorDesc={loc(assetErrorWeather)}
                    retryCallback={fetchWeatherCallback}
                />
            )}
        </div>
    );
});
